<template>
  <div class="gallery-modal-overlay">
    <div class="gallery-modal-content" @click.stop>
      <!-- Header da Galeria -->
      <div class="gallery-header">
        <h2 class="gallery-title">Galeria de Fotos</h2>
        <button @click="handleCancel" class="cancel-button">Cancelar</button>
      </div>

      <!-- Grid de Fotos -->
      <div class="gallery-grid ph-no-capture">
        <div
          v-for="(photo, index) in gallery"
          :key="index"
          class="photo-container"
        >
          <!-- Foto existente -->
          <div v-if="photo" class="photo-item">
            <img
              :src="photo"
              :alt="`Foto ${index + 1}`"
              class="photo-image"
              @click="openPhotoViewer(photo, index)"
              draggable="false"
              @contextmenu.prevent
              @dragstart.prevent
            />
            <button
              @click.stop="deletePhoto(index)"
              class="delete-button"
              title="Remover foto"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="2"
                stroke="currentColor"
                class="w-6 h-6"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
                />
              </svg>
            </button>
            <div class="photo-number">{{ index + 1 }}</div>
          </div>

          <!-- Placeholder para foto faltante -->
          <div v-else class="photo-placeholder" @click="handlePlaceholderClick">
            <div class="placeholder-content">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="placeholder-icon"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M12 4.5v15m7.5-7.5h-15"
                />
              </svg>
              <span class="placeholder-text">Capturar foto novamente</span>
            </div>
            <div class="pulse-animation"></div>
          </div>
        </div>
      </div>

      <!-- Footer com Botão de Confirmação -->
      <div class="gallery-footer">
        <button
          v-if="isGalleryComplete"
          @click="confirmPhotos"
          class="confirm-button confirm-button-large"
        >
          Próximo Passo
        </button>
        <div v-else class="footer-content">
          <div class="photo-counter">
            {{ filledCount }}/{{ maxPhotos }} fotos
          </div>
          <button
            @click="confirmPhotos"
            class="confirm-button confirm-button-large"
          >
            Capturar Foto novamente
          </button>
        </div>
      </div>
    </div>

    <!-- Modal de Visualização de Foto -->
    <div
      v-if="showPhotoViewer"
      class="photo-viewer-overlay"
      @click="closePhotoViewer"
    >
      <div class="photo-viewer-content" @click.stop>
        <button @click.stop="closePhotoViewer" class="photo-viewer-close">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="2"
            stroke="currentColor"
            class="w-8 h-8"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
        <img
          :src="selectedPhoto"
          :alt="`Foto ${selectedPhotoIndex + 1}`"
          class="photo-viewer-image ph-no-capture"
          draggable="false"
          @contextmenu.prevent
          @dragstart.prevent
        />
        <div class="photo-viewer-info">
          <span class="photo-viewer-number"
            >Foto {{ selectedPhotoIndex + 1 }}</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "vGaleria",
  props: {
    gallery: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      showPhotoViewer: false,
      selectedPhoto: null,
      selectedPhotoIndex: 0,
    };
  },
  watch: {
    gallery: {
      handler() {},
      deep: true,
      immediate: true,
    },
  },
  computed: {
    maxPhotos() {
      return this.gallery.length;
    },
    filledCount() {
      return this.gallery.filter((photo) => photo !== null).length;
    },
    isGalleryComplete() {
      return this.gallery.every((photo) => photo !== null);
    },
  },
  methods: {
    deletePhoto(index) {
      this.$emit("deletePhoto", index);
    },

    handlePlaceholderClick() {
      this.$emit("backToSelfie");
    },

    confirmPhotos() {
      if (this.isGalleryComplete) {
        this.$emit("confirmPhotos");
      } else {
        this.$emit("backToSelfie");
      }
    },

    handleCancel() {
      // Emitir evento para voltar à escolha de envio
      this.$emit("cancelGallery");
    },

    openPhotoViewer(photo, index) {
      this.selectedPhoto = photo;
      this.selectedPhotoIndex = index;
      this.showPhotoViewer = true;
    },

    closePhotoViewer() {
      this.showPhotoViewer = false;
      this.selectedPhoto = null;
      this.selectedPhotoIndex = 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.gallery-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  backdrop-filter: blur(4px);
}

.gallery-modal-content {
  width: 95vw;
  height: 90vh;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 24px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
}

.gallery-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 32px;
  border-bottom: 2px solid #f1f5f9;
  background: linear-gradient(135deg, #8c2667 0%, #978fc4 100%);
  color: white;
}

.gallery-title {
  font-size: 2rem;
  font-weight: 700;
  margin: 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.cancel-button {
  background: rgba(255, 255, 255, 0.2);
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 12px;
  padding: 12px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  cursor: pointer;
  transition: all 0.2s ease;
  backdrop-filter: blur(10px);
  font-size: 1rem;
  font-weight: 600;
  min-width: 100px;

  &:hover {
    background: rgba(255, 255, 255, 0.3);
    border-color: rgba(255, 255, 255, 0.5);
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
    background: rgba(255, 255, 255, 0.4);
  }
}

.gallery-grid {
  flex: 1;
  padding: 32px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 24px;
  overflow-y: auto;
  align-content: start;
}

.photo-container {
  position: relative;
  aspect-ratio: 1;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 35px rgba(0, 0, 0, 0.15);
  }
}

.photo-item {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.photo-image {
  width: 100%;
  height: 100%;
  object-fit: fill;
  border-radius: 16px;
  cursor: pointer;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.05);
  }
}

.delete-button {
  position: absolute;
  top: 8px;
  right: 8px;
  background: #ef4444;
  border: 3px solid white;
  border-radius: 50%;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  cursor: pointer;
  transition: all 0.2s ease;
  z-index: 20;
  box-shadow: 0 4px 16px rgba(239, 68, 68, 0.4);
  font-weight: bold;

  &:hover {
    background: #dc2626;
    transform: scale(1.15);
    box-shadow: 0 6px 20px rgba(239, 68, 68, 0.6);
  }

  &:active {
    transform: scale(0.95);
    background: #b91c1c;
  }
}

.photo-number {
  position: absolute;
  bottom: 8px;
  left: 8px;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  border-radius: 20px;
  padding: 4px 12px;
  font-size: 0.875rem;
  font-weight: 600;
  backdrop-filter: blur(10px);
  z-index: 5;
}

.photo-placeholder {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  border: 3px dashed #cbd5e1;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;

  &:hover {
    border-color: #8c2667;
    background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
    transform: scale(1.02);
  }

  &:active {
    transform: scale(0.98);
  }
}

.placeholder-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  z-index: 2;
  position: relative;
}

.placeholder-icon {
  width: 48px;
  height: 48px;
  color: #94a3b8;
  transition: color 0.3s ease;
}

.photo-placeholder:hover .placeholder-icon {
  color: #8c2667;
}

.placeholder-text {
  font-size: 0.875rem;
  font-weight: 600;
  color: #64748b;
  text-align: center;
  transition: color 0.3s ease;
}

.photo-placeholder:hover .placeholder-text {
  color: #475569;
}

.pulse-animation {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 3px solid transparent;
  border-radius: 16px;
  background: linear-gradient(45deg, #8c2667, #978fc4, #a78ebd);
  background-size: 400% 400%;
  animation: pulse-border 2s ease-in-out infinite;
  opacity: 0.3;
}

@keyframes pulse-border {
  0% {
    background-position: 0% 50%;
    transform: scale(1);
    opacity: 0.3;
  }
  50% {
    background-position: 100% 50%;
    transform: scale(1.05);
    opacity: 0.6;
  }
  100% {
    background-position: 0% 50%;
    transform: scale(1);
    opacity: 0.3;
  }
}

.gallery-footer {
  padding: 24px 32px;
  border-top: 2px solid #f1f5f9;
  background: #f8fafc;
  display: flex;
  align-items: center;
  justify-content: center;
}

.footer-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  width: 100%;
}

.photo-counter {
  font-size: 1.125rem;
  font-weight: 600;
  color: #475569;
  background: white;
  padding: 12px 20px;
  border-radius: 12px;
  border: 2px solid #e2e8f0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.confirm-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: linear-gradient(135deg, #8c2667 0%, #978fc4 100%);
  color: white;
  border: none;
  border-radius: 10px;
  height: 48px;
  padding: 0 20px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(140, 38, 103, 0.25);

  &:hover:not(.disabled) {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(140, 38, 103, 0.35);
  }

  &:active:not(.disabled) {
    transform: translateY(0);
  }

  &.disabled {
    background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(245, 158, 11, 0.25);

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(245, 158, 11, 0.35);
    }
  }
}

.confirm-button-large {
  width: 100%;
  height: 60px;
  font-size: 1.25rem;
  font-weight: 700;
  border-radius: 16px;
  background: linear-gradient(135deg, #8c2667 0%, #978fc4 100%);
  box-shadow: 0 4px 16px rgba(140, 38, 103, 0.3);
  animation: button-pulse 2s ease-in-out infinite;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.2),
      transparent
    );
    animation: shimmer 3s ease-in-out infinite;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(140, 38, 103, 0.4);
    animation-play-state: paused;
  }

  &:active {
    transform: translateY(0);
  }
}

@keyframes button-pulse {
  0% {
    box-shadow: 0 4px 16px rgba(140, 38, 103, 0.3);
    transform: scale(1);
  }
  50% {
    box-shadow: 0 6px 24px rgba(140, 38, 103, 0.5);
    transform: scale(1.02);
  }
  100% {
    box-shadow: 0 4px 16px rgba(140, 38, 103, 0.3);
    transform: scale(1);
  }
}

@keyframes shimmer {
  0% {
    left: -100%;
  }
  50% {
    left: 100%;
  }
  100% {
    left: 100%;
  }
}

/* Telas muito grandes: manter o botão compacto */
@media (min-width: 1920px) {
  .confirm-button {
    height: 50px;
    padding: 0 22px;
    font-size: 1rem;
  }
}

/* Garantir que o botão de exclusão seja sempre visível */
.delete-button svg {
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.3));
}

/* Responsividade */
@media (max-width: 768px) {
  .gallery-modal-content {
    width: 100vw;
    height: 100vh;
    border-radius: 0;
  }

  .gallery-header {
    padding: 20px 24px;
  }

  .gallery-title {
    font-size: 1.5rem;
  }

  .gallery-grid {
    padding: 20px;
    gap: 16px;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  }

  .gallery-footer {
    padding: 20px 24px;
  }

  .footer-content {
    flex-direction: column;
    gap: 16px;
  }

  .confirm-button {
    width: 100%;
    justify-content: center;
  }

  .confirm-button-large {
    height: 56px;
    font-size: 1.125rem;
  }
}

@media (max-width: 480px) {
  .gallery-grid {
    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
    gap: 12px;
    padding: 16px;
  }

  .photo-placeholder .placeholder-icon {
    width: 36px;
    height: 36px;
  }

  .placeholder-text {
    font-size: 0.75rem;
  }

  .confirm-button-large {
    height: 52px;
    font-size: 1rem;
  }
}

/* Scrollbar personalizada */
.gallery-grid::-webkit-scrollbar {
  width: 8px;
}

.gallery-grid::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 4px;
}

.gallery-grid::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;

  &:hover {
    background: #94a3b8;
  }
}

/* Estilos do Modal de Visualização de Foto */
.photo-viewer-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  backdrop-filter: blur(8px);
  animation: fadeIn 0.3s ease;
}

.photo-viewer-content {
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  animation: zoomIn 0.3s ease;
}

.photo-viewer-close {
  position: absolute;
  top: -60px;
  right: 0;
  background: rgba(255, 255, 255, 0.2);
  border: none;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  cursor: pointer;
  transition: all 0.2s ease;
  backdrop-filter: blur(10px);
  z-index: 10001;

  &:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: scale(1.1);
  }

  &:active {
    transform: scale(0.95);
  }
}

.photo-viewer-image {
  max-width: 100%;
  max-height: 80vh;
  object-fit: contain;
  border-radius: 12px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.02);
  }
}

.photo-viewer-info {
  margin-top: 20px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 8px 16px;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.photo-viewer-number {
  color: white;
  font-size: 1rem;
  font-weight: 600;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes zoomIn {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* Responsividade para o modal de visualização */
@media (max-width: 768px) {
  .photo-viewer-content {
    max-width: 95vw;
    max-height: 95vh;
  }

  .photo-viewer-close {
    top: -50px;
    width: 44px;
    height: 44px;
  }

  .photo-viewer-image {
    max-height: 75vh;
  }

  .photo-viewer-info {
    margin-top: 16px;
    padding: 6px 12px;
  }

  .photo-viewer-number {
    font-size: 0.875rem;
  }
}

@media (max-width: 480px) {
  .photo-viewer-close {
    top: -45px;
    width: 40px;
    height: 40px;
  }

  .photo-viewer-image {
    max-height: 70vh;
  }
}
</style>
